import { create } from 'zustand';
import { createNavigationSlice } from './navigation/createNavigationSlice';
import { createSettingsSlice } from './settings/createSettingsSlice';
import { TrainingState } from './TrainingState';
import { createUserSlice } from './user/createUserSlice';
import { createSaveQuestionAnswersRequest } from '~/training/state/question/saveQuestionAnswers';

export const useTrainingStore = create<TrainingState>((set, get, api) => ({
  ...createUserSlice(set, get, api),
  ...createSettingsSlice(set, get, api),
  ...createNavigationSlice(set, get, api),
  ...createSaveQuestionAnswersRequest(set, get, api),
  chatMessages: []
}));
